// components/DeleteConfirmDialog.js

import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogContentText,
  DialogActions, Button, Snackbar, Alert
} from '@mui/material';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/config';

const DeleteConfirmDialog = ({ open, handleClose, sensor, refreshSensors }) => {
  const [error, setError] = useState('');
  
  // Snackbar state
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success' // 'success' | 'error' | 'warning' | 'info'
  });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({
      ...prev,
      open: false
    }));
  };

  const handleDelete = async () => {
    try {
      // Make API call to delete sensor
      const response = await axios.delete(`${API_BASE_URL}api/sensor/delete/${sensor._id}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        }
      });

      // Handle success
      console.log('Sensor deleted:', response.data);
      setSnackbar({
        open: true,
        message: 'Sensor deleted successfully.',
        severity: 'success'
      });
      handleClose();
      refreshSensors();
    } catch (error) {
      console.error('Error deleting sensor:', error);
      // Optionally, set error state to display error messages
      if (error.response && error.response.data && error.response.data.message) {
        setSnackbar({
          open: true,
          message: error.response.data.message,
          severity: 'error'
        });
      } else {
        setSnackbar({
          open: true,
          message: 'Failed to delete sensor.',
          severity: 'error'
        });
      }
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Delete Sensor</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete the sensor "{sensor.sensor_name}" with Sub ID "{sensor.sensor_sub_id}"?
          This action cannot be undone.
        </DialogContentText>
        {error && <p style={{ color: 'red', fontSize: '0.8rem' }}>{error}</p>}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary" variant="outlined">
          Cancel
        </Button>
        <Button onClick={handleDelete} color="error" variant="contained">
          Delete
        </Button>
      </DialogActions>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Dialog>
  );
};

export default DeleteConfirmDialog;
